
























import Vue from "vue"
import GrafanaGraph from './GrafanaGraph.vue'

export default Vue.extend({
  props: ['storyname'],

  data() {
    return {
      // for example: 'http://fat.thenetcircle.lab:3003/dashboard-solo/db/event-bus-final?var-Community=kauf&var-StoryName={storyName}&var-Prefix=event-bus&theme=light&panelId={panelId}'
      grafanaUrl: GRAFANA_URL
    }
  },

  components: {
    GrafanaGraph
  },

  computed: {
    urlOfProcessedEvents(): string {
      return this.grafanaUrl.replace('{storyName}', this.storyname).replace('{panelId}', '3')
    },

    urlOfCompletedStreams(): string {
      return this.grafanaUrl.replace('{storyName}', this.storyname).replace('{panelId}', '73')
    },

    urlOfExceptions(): string {
      return this.grafanaUrl.replace('{storyName}', this.storyname).replace('{panelId}', '74')
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StoryStatistics.vue